<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M35.7967 33.6495C21.8175 33.6383 34.2182 92.2161 50.1268 87.2528"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M87.4374 107.292H45.8691"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M87.4374 112.035H45.8691"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.0436 32.7987C37.0436 32.7987 35.5957 58.2569 39.8723 71.292C48.6196 97.9481 81.5824 102.247 81.6794 91.8242C81.8585 72.0495 -8.40945 107.326 63.5094 107.292"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M77.4652 69.3999H42.0917C40.8674 69.3999 39.875 70.3923 39.875 71.6166V71.6203C39.875 72.8445 40.8674 73.837 42.0917 73.837H77.4652C78.6894 73.837 79.6819 72.8445 79.6819 71.6203V71.6166C79.6819 70.3923 78.6894 69.3999 77.4652 69.3999Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.2207 38.9336V48.1213C85.2207 55.2975 79.3954 61.1228 72.2192 61.1228C65.043 61.1228 59.2177 55.2975 59.2177 48.1213V38.9336C59.2177 31.7574 65.043 25.9321 72.2192 25.9321C79.3954 25.9321 85.2207 31.7574 85.2207 38.9336Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.6408 29.1641H70.7972C66.1867 29.1641 62.4492 32.9016 62.4492 37.512V49.5433C62.4492 54.1538 66.1867 57.8913 70.7972 57.8913H73.6408C78.2513 57.8913 81.9888 54.1538 81.9888 49.5433V37.512C81.9888 32.9016 78.2513 29.1641 73.6408 29.1641Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.0023 29.1641H74.4357C78.6041 29.1641 81.9888 32.5488 81.9888 36.7172H62.4492C62.4492 32.5488 65.8339 29.1641 70.0023 29.1641Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M81.9835 51.3046C77.05 51.9502 66.7205 52.3085 66.7914 47.4758C66.8623 42.6432 74.0795 42.2065 73.2697 43.8821C71.4524 47.6437 77.8412 41.6132 81.9872 41.5199"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M45.3359 64.9219V38.7659C45.3359 26.1711 55.5461 15.9647 68.1371 15.9647H75.4812C88.076 15.9647 98.2824 26.1749 98.2824 38.7659V74.2402C98.2824 82.4501 93.9423 89.645 87.4341 93.6603"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
